import Chart from 'chart.js/auto';

const chartsOptions = [{
    type: 'bar',
    options: {
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: false
            }
        },
        scales: {
            yAxis: {
                display: false
            },
            xAxis: {
                display: false
            }
        }
    },
}, {
    type: 'line',
    options: {
        elements: {
            line: {
                borderWidth: 7,
            }
        },
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: false
            }
        },
        scales: {
            yAxis: {
                display: false
            },
            xAxis: {
                display: false
            }
        }
    },
}, {
    type: 'doughnut',
    options: {
        elements: {
            arc: {
                borderWidth: 0
            }
        },
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: false,
            }
        }
    },
}];

(function () {

    if (typeof window.tatox === 'undefined' || typeof window.tatox.chartsData === 'undefined') return;

    const {chartsData} = window.tatox;

    chartsData.map(data => {
        const {title, datasets, labels, type, canvasId} = data;

        if (!title || !datasets || !labels || !type || !canvasId) {
            return console.error(`Chart config isn't valid:
           ${JSON.stringify(data, null, 2)}`);
        }

        const options = chartsOptions.find(options => options.type.toLowerCase() === type.toLowerCase());

        if (!options) {
            return console.error(`No configuration provided for chart type "${data.type}"`);
        }

        const element = document.getElementById(data.canvasId);

        if (!element) return;

        const config = {
            type: options.type,
            options: options.options,
            title,
            data: {
                datasets,
                labels
            }
        }
        return new Chart(element.getContext('2d'), config);
    });
})();
